const axios = require('axios');
axios.defaults.withCredentials = true
const CancelToken = axios.CancelToken;

import { LISTINGS_URL, FEATURED_URL, FEATURED_IDS_URL } from '../components/settings'
import { NEIGHBORHOODS_URL } from "../components/settings"

function formatDate(date){
  return (date.getMonth() + 1) + '/' + date.getDate() + '/' +  date.getFullYear()
}

// function getPetFriendly(catFriendly, dogFriendly){
//   if (catFriendly && dogFriendly) return "friendly";
//   if (dogFriendly) return "dog";
//   return catFriendly ? "cat": null;
// }

export const requestWasCancelled = thrown => {
  return axios.isCancel(thrown)
}

export const searchRentals = function({
  beds = [],
  baths = [],
  availFrom, 
  availTo, 
  minRent, 
  maxRent,
  pets = [], 
  noFeeOnly = false,
  photosOnly = true,
  locations = [],
  streetName = "",
  listingIDs = "",
  listingsPerPage = 30, 
  pageNumber = 1, 
  sortDirection = "asc",
  updatedSince,
  sortName = "city",
  cancelToken,
  groupID
}){
  const parameters = (listingIDs || groupID)
  ? {
    listing_ids: listingIDs,
    group_id: groupID,
    include_off_market: 1,
    include_mls: 1
  }
  : {
    beds: beds.join(),
    baths: baths.join(),
    avail_from: availFrom ? formatDate(availFrom) : null,
    avail_to: availTo ? formatDate(availTo) : null,
    updated_since: updatedSince ? formatDate(updatedSince) : null,

    min_rent: minRent == 0 ? null : minRent,
    max_rent: maxRent == 0 ? null : maxRent,
    pet: (pets.length == 2) ? "friendly" : pets[0],
    listing_fee: noFeeOnly ? 1 : null,
    photo: photosOnly ? "Y" : null,
    city_neighborhood: locations.join(),
    street_name: streetName
  }
  const pageOptions = {
    page_count: listingsPerPage,
    page_index: pageNumber,
    sort_dir: sortDirection,
    sort_name: sortName
  }
  return Promise.resolve(
    axios.get(LISTINGS_URL, {
      params: {...parameters, ...pageOptions},
      cancelToken: new CancelToken(cancelFunction => {
        if (cancelToken) cancelToken.cancel = cancelFunction;
      })
    })
    .then(apiResponse => {
      return {listings: apiResponse.data.YGLResponse.Listings, totalNumber: parseInt(apiResponse.data.YGLResponse.Total)};
    })
    // .catch(error => {
    //   if (!axios.isCancel(error)) {
    //     errorFunction();
    //   }
    // })
  )
}

export const getNeighborhoods = function(){
  return axios.get(NEIGHBORHOODS_URL, {
    params: {}
  })
  .then(apiResponse => {
    return apiResponse.data;
  })
  // .catch(error => {
  //   if (!axios.isCancel(error)) {
  //     this.console.log("Unable to access neighborhood data for search form: " + error);
  //   }
  // });
}

export const getMonthShortcuts = function(){
  const now = new Date();
  const shortcuts = [];
  for (var i = 0; i < 10; i++){
    const futureMonth = new Date(now.getFullYear(), now.getMonth() + i);
    shortcuts.push({
      text: futureMonth.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }),
      //onClick: new Function('picker', "picker.$emit('pick', new Date('" + futureMonth.toString() + "'));")
      onClick(picker){ picker.$emit('pick', futureMonth) }
    });
  }
  return shortcuts;
}

export const getFeaturedListings = async function(){
  const response = await axios.get(FEATURED_URL)
  return response.data.YGLResponse.Listings;
}

export const getFeaturedListingsIds = async function(){
  const response = await axios.get(FEATURED_IDS_URL + "/ids", { withCredentials: true })
  return response.data;
}

export const addFeaturedListing = async function(listingId){
  const response = await axios.post(FEATURED_IDS_URL, null, { params:{ id: listingId} } )
  return response.data;
}

export const removeFeaturedListing = async function(listingId){
  const response = await axios.delete(FEATURED_IDS_URL, { params:{ id: listingId} })
  return response.data;
}